import { IUserState } from './types'
export const initialState: IUserState = {
  imagesLoaded: false,
  username: undefined,
  lastLocation: '',
  userAvdeling: {},
  userOrgenhet: {},
  accessToken: '',
}
